<template>
  <v-card
    class="red-button pb-2 pt-2 px-2 d-flex justify-center"
    :width="width"
  >
    <v-switch
      v-model="active"
      dense
      color="grey lighten-2"
      class="py-0 my-0"
      hide-details
      :disabled="disabled"
    >
      <template #label>
        <span class="text-body-2 text-white font-weight-bold">
          {{ label }}
        </span>
      </template>
    </v-switch>
  </v-card>
</template>

<script>
  export default {
    name: 'BoxedSwitch',

    props: {
      value: Boolean,
      label: {
        type: String,
        required: true,
      },
      width: {
        type: String,
        default: '200px',
      },
      disabled: Boolean,
    },
    computed: {
      active: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
    },
  };
</script>
